<template>
  <el-card
    id="coachingCategoryCard"
    class="mainCard clear-card defaultCursor"
    :body-style="{
      padding: '35px 30px 40px'
    }"
  >
    <div class="title">
      {{ $t('coach.category.selector.title') }}
    </div>

    <div class="body">
      <p
        v-for="item in 3"
        :key="`desc${item}`"
      >
        {{ $t(`coach.category.selector.desc_${item}`) }}
      </p>

      <div>
        <div class="subtitle">
          {{ $t('coach.category.tips') }}
        </div>

        <ul>
          <li
            v-for="item in 2"
            :key="`tip${item}`"
          >
            {{ $t(`coach.category.selector.tip_${item}`) }}
          </li>
        </ul>
      </div>

      <CategoryTable
        :category-loading="categoryLoading"
        :categories="categories"
      />

      <div class="additionalDesc caption">
        {{ $t('coach.category.additionalDesc') }}
      </div>

      <div>
        <div class="subtitle">
          {{ $t('coach.category.matching.title') }}
        </div>

        <p>
          {{ $t('coach.category.matching.desc_1') }}
        </p>
      </div>

      <el-row
        :gutter="5"
      >
        <el-col :span="responsiveCol">
          <div class="subtitle">
            {{ $t('coach.category.matching.impact.title') }}
          </div>
          <ul>
            <li
              v-for="item in 3"
              :key="`impact_${item}`"
            >
              {{ $t(`coach.category.matching.impact.desc_${item}`) }}
            </li>
          </ul>
        </el-col>
        <el-col :span="responsiveCol">
          <div class="subtitle">
            {{ $t('coach.category.matching.background.title') }}
          </div>
          <ul>
            <li
              v-for="item in 4"
              :key="`bg_${item}`"
            >
              {{ $t(`coach.category.matching.background.desc_${item}`) }}
            </li>
          </ul>
        </el-col>
      </el-row>

      <p>
        {{ $t('coach.category.matching.desc_2') }}
      </p>

      <p>
        {{ $t('coach.category.matching.desc_3') }}
      </p>

      <div>
        <div class="subtitle">
          {{ $t('coach.category.tips') }}
        </div>
        <ul>
          <li
            v-for="item in 2"
            :key="`matchingTip_${item}`"
          >
            {{ $t(`coach.category.matching.tip_${item}`) }}
          </li>
        </ul>
      </div>

      <div class="caption">
        {{ $t('coach.category.disclaimer') }}:
        <ul style="margin-top: 0;">
          <li
            v-for="item in 2"
            :key="`cap_${item}`"
          >
            <i18n :path="`coach.category.caption_${item}`">
              <template #link>
                <a
                  class="coloredAnchor"
                  href="https://info.gcgroup.io/platform/payouts/"
                  target="_blank"
                >
                  https://info.gcgroup.io/platform/payouts/
                </a>
              </template>
            </i18n>
          </li>
        </ul>
      </div>
    </div>
  </el-card>
</template>

<script>
import CategoryTable from './CategoryTable.vue';

export default {
  name: 'CoachingCategories',

  components: {
    CategoryTable,
  },

  props: {
    categoryLoading: {
      type: Boolean,
      default: false,
    },

    categories: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    responsiveCol() {
      let col = 12;
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col = 24;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
  #coachingCategoryCard {
    .title {
      font-weight: bold;
      font-size: 18px;
    }

    .body {
      padding: 20px 0 0;
      line-height: 1.4rem;

      .additionalDesc {
        padding-bottom: 18px;
      }

      .subtitle {
        font-weight: bold;
        margin-top: 18px;
      }

      .caption {
        padding-top: 10px;
        font-size: 15px;
        font-style: italic;
        font-weight: lighter;
        opacity: 0.7;
      }

      .coloredAnchor {
        color: var(--themeFontColor);
      }

      ul {
        margin: 12px 0;

        li {
          padding: 4px 0;
        }
      }
    }
  }
</style>
